const markdownTest = `# Accessibility Test: Code Snippets

This paragraph contains inline code: \`calculateTotal(price, taxRate)\`.

## Python Example

\`\`\`python
def calculate_total(price, tax_rate=0.07):
    """
    Calculate the final price after tax.
    """
    total = price * (1 + tax_rate)
    return round(total, 2)

# Example usage
print(calculate_total(19.99))
\`\`\`

## JavaScript Example

\`\`\`javascript
function greetUser(name) {
    console.log(\`Hello, \${name}!\`);
}

greetUser("Alice");
\`\`\`

## Special Characters

\`\`\`text
< > { } [ ] ( )
&& || !
== != <= >=
$ @ # % ^
\`\`\`

The filename is \`main.py\`.

The keyboard shortcut is \`Ctrl + Shift + P\`.`;

export default markdownTest;